export default __webpack_public_path__ + "static/media/heating_cooling.4550bb21.svg";